import mixins from './mixins';

const theme = {
  // ============================
  // 🌈 COLOR PALETTE (from your cursor image)
  // ============================
  colors: {
    // Gradient colors
    cyan: '#BFF6FF',        // icy light blue
    lavender: '#CDA7F9',    // soft purple
    magenta: '#D64FAF',     // bright magenta accent
    deepPink: '#B40073',    // deep fuchsia

    // Main site accent (replaces original "green")
    green: '#D64FAF',

    // Dark purple backgrounds
    navy: '#0D0311',
    darkNavy: '#08020B',
    lightNavy: '#1A0C22',
    lightestNavy: '#281032',

    // Text colors (warm violet)
    slate: '#B59FCB',
    lightSlate: '#D5CBE4',
    lightestSlate: '#EEE7F7',
    white: '#FFFFFF',
  },

  // ============================
  // 📱 BREAKPOINTS
  // ============================
  bp: {
    mobileS: `max-width: 330px`,
    mobileM: `max-width: 400px`,
    mobileL: `max-width: 480px`,
    tabletS: `max-width: 600px`,
    tabletL: `max-width: 768px`,
    desktopXS: `max-width: 900px`,
    desktopS: `max-width: 1080px`,
    desktopM: `max-width: 1200px`,
    desktopL: `max-width: 1400px`,
  },

  // ============================
  // 🧩 MIXINS
  // ============================
  mixins,
};

export default theme;
